module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABXUlEQVRIS9WUz0rDQBDGv13wKHgSQfAxfAHfw0uSiUcp+KdqEapiWxBvHnY2+C6CDyIIKh4FjzsSaUsSk+42oQfnujvfb2Z29lNYcagV66MESNN0X0TWu0Cdc9/W2seZRglARK8AtrsAROSTmTebAC8AdjoCPph5qxYQx/GR1nqjC8A592WtHdUCugg35S61RUQ0BrBmjOmFFhMMIKIhgMFUeGSM6YdAggBEdAPgrCIYBPECKpVXi/ZCFgKSJLlSSl0sGoWIjJn5dOlHJqJrAOchcxaRW2aujvA3tbaDZcRnBYjIhJlPqgX9AbQRL4hOjDElSNWLUhE5UErJNCn3FJ83vQF4L3Rimfkh6CfHcXyotb73vEPfGDO3Bu+IiheSJOkppe48WzRg5nwhasO3pv8cQETHAHKDawwRGTLzZasRRVG0q7XeWwRwzj1lWfbcChDyi313vGbnE/Cd/wCzjY4ZTHzYpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hover_btn_top_nor.png
// module id = JeCs
// module chunks = 1